<template>
  <div class='logger'>
    <div class='ly-card hd'>
      <div class='search-box'>
        <div class='search-field'>
          <el-input v-model='searchFormData.operate_name' placeholder='操作人检索' clearable />
          <el-select v-model='searchFormData.module' placeholder='操作模块' clearable>
            <el-option
              v-for='item in modules'
              :key='item.value'
              :label='item.label'
              :value='item.value'>
            </el-option>
          </el-select>
          <el-select v-model='searchFormData.event_type' placeholder='操作类型' clearable>
            <el-option
              v-for='item in events'
              :key='item.value'
              :label='item.label'
              :value='item.value'>
            </el-option>
          </el-select>
          <el-date-picker
            v-model="searchFormData.date"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd HH:mm:ss"
            :default-time="['00:00:00', '23:59:59']"
          clearable>
          </el-date-picker>
        </div>
        <div>
          <el-button type='primary' @click='search()'>查询</el-button>
        </div>
      </div>
    </div>
    <ly-table
      :getTableData='getTableData'
      :tableHeader='tableHeader'
      :searchFormData='searchFormData'
      :tableConfig='tableConfig'
      class='ly-card'
      ref='lyTable'
    >
    </ly-table>
  </div>
</template>

<script>
import LyTable from '@/components/LyTable';
import { logger } from '@/api';
import { Input, Select, Option, DatePicker } from 'element-ui';
import dayjs from 'dayjs';
/*
0
:
{label: "登录页", value: 1}
1
:
{label: "缴费查询", value: 2}
2
:
{label: "集体报名", value: 3} */


/* {label: "登录", value: 1}
1
:
{label: "退出", value: 2}
2
:
{label: "查看缴费详情", value: 3}
3
:
{label: "补费申请", value: 4}
4
:
{label: "退缴费", value: 5}
5
:
{label: "导出", value: 6}
6
:
{label: "一键激活集体报名", value: 7}
7
:
{label: "代缴费短信发送", value: 8}
8
:
{label: "报名", value: 9}
9
:
{label: "查看报名详情", value: 10}
10
:
{label: "集体报名异常情况登记", value: 11}
11
:
{label: "批量激活", value: 12}
12
:
{label: "批量撤销", value: 13}
13
:
{label: "批量导出", value: 14} */
export default {
  name: 'Logger',
  components: {
    LyTable,
    ElInput: Input,
    ElSelect: Select,
    ElOption: Option,
    ElDatePicker: DatePicker
  },
  data() {
    return {
      getTableData: logger.fetchLoggerList,
      tableConfig: {
        border: true,
        align: 'center'
      },
      searchFormData: {
        operate_name: undefined,
        module: undefined,
        event_type: undefined,
        date: []
      },
      tableHeader: [
        {
          name: '操作人',
          value: 'operate_name'
        },
        {
          name: '操作模块',
          value: 'module_label'
        },
        {
          name: '操作类型',
          value: 'event_type_label'
        },
        {
          name: '操作内容',
          value: 'cusp'
        },
        {
          name: '操作时间',
          value: 'server_ts'
        },
        {
          name: 'IP地址',
          value: 'ip'
        }
      ],
      modules: [],
      events: []
    };
  },
  mounted() {
    this.search();
    this.getLoggerModuleAndEvent();
  },
  methods: {
    search() {
      if (this.searchFormData.date && this.searchFormData.date.length === 2) {
        this.searchFormData = {
          ...this.searchFormData,
          start_time: this.searchFormData.date[0],
          end_time: this.searchFormData.date[1]
        };
      } else {
        delete this.searchFormData.start_time;
        delete this.searchFormData.end_time;
      }
      this.$refs.lyTable.setData();
    },
    async getLoggerModuleAndEvent() {
      const [moduleRes, eventRes] = await Promise.all([logger.fetchLoggerModule(), logger.fetchLoggerEvent()]);
      this.modules = moduleRes.data;
      this.events = eventRes.data;
    }
  },
  watch: {
    'searchFormData.module': {
      handler(val) {
        this.searchFormData.event_type = undefined;
        logger.fetchLoggerEvent(val ? { module: val } : {}).then(res => {
          this.events = res.data;
        });
      }
    }
  }

};
</script>

<style lang='less' scoped>
.search-box {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 40px;

  .search-field {
    display: flex;
    align-items: center;
    gap: 20px;
    flex: 1;
  }
}
</style>
<style lang='less'>
.logger {
  .search-box {
    .el-input {
      width: 140px;
    }
    .el-select {
      width: 140px;
    }
  }
}
</style>
